export function dataURLToFile(dataURL: string, fileName: string): File {
    const splitDataURL = dataURL.split(',');
    const mimeTypeMatch = splitDataURL[0].match(/:(.*?);/);
    const mimeType = mimeTypeMatch ? mimeTypeMatch[1] : '';
    const base64Data = splitDataURL[1];
    const binaryData = atob(base64Data);
    const binaryDataLength = binaryData.length;
    const binaryArray = new Uint8Array(binaryDataLength);
    for (let i = 0; i < binaryDataLength; i++) {
        binaryArray[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([binaryArray], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
}
